<template>
  <div class="row">
    <div class="col-md-12">
      <div class="category-top-bar">
        <div class="top-bar">
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </div>
      </div>
      <p class="clearfix"></p>
      <coupon-form :route="route"></coupon-form>
    </div>
  </div>
</template>
<script>
  import CouponForm from './CouponForm.vue'
  // used for both /marketing/coupons/add and /marketing/coupons/edit/:id
  export default {
    components: {
      CouponForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/DiscountCoupons/CouponPage.vue